module.exports = __webpack_public_path__ + "img/img3.c85f1e2c.png";